<script setup lang="ts">
import { computed, inject, unref } from "vue";
import { Heading } from "~/components/clarity-ui/Heading";
import type { IconListProps } from "../";

export interface IconListItemProps {
  heading?: string;
  image?: {
    src: string;
  };
  size?: "medium" | "small";
}

const { size } = defineProps<IconListItemProps>();

const iconListProps = inject<IconListProps>("iconListContext", {});

const computedSize = computed(() => size || iconListProps?.size || "medium");
const computedWidth = computed(() => (unref(computedSize) === "small" ? 18 : 24));
</script>

<template>
  <li
    v-if="image?.src || heading || $slots.default"
    class="flex items-start gap-x-3"
    :class="{ 'text-sm': computedSize === 'small' }"
  >
    <img
      v-if="image?.src"
      :width="computedWidth"
      :height="computedWidth"
      :src="image?.src"
      alt=""
      data-testid="image"
    />
    <template v-if="heading">
      <div class="flex flex-col">
        <Heading color="blue" size="small" data-testid="icon-list-heading">{{ heading }}</Heading>
        <slot />
      </div>
    </template>
    <template v-else-if="$slots.default"><slot /></template>
  </li>
</template>
